"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _getFormMethods2 = _interopRequireDefault(require("../Form/getFormMethods"));

var _Dropdown = require("./Dropdown.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Dropdown = function Dropdown(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      firstOptionText = _ref.firstOptionText,
      floatingLabel = _ref.floatingLabel,
      id = _ref.id,
      label = _ref.label,
      secondaryLabel = _ref.secondaryLabel,
      showSecondaryLabel = _ref.showSecondaryLabel,
      onChange = _ref.onChange,
      options = _ref.options,
      readOnly = _ref.readOnly,
      size = _ref.size,
      validations = _ref.validations,
      value = _ref.value;

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1];

  var _getFormMethods = (0, _getFormMethods2["default"])({
    mode: 'onBlur'
  }),
      errors = _getFormMethods.errors,
      register = _getFormMethods.register,
      setValue = _getFormMethods.setValue;

  var fieldErrors = error || errors[id];
  var required = (0, _get["default"])(validations, 'required');
  (0, _react.useEffect)(function () {
    setState(value);
    setValue(id, value);
  }, [id, setValue, value]);
  var handleBlur = (0, _react.useCallback)(function (event) {
    setState(event.target.value);
    setFocus(false);
  }, []);
  var handleChange = (0, _react.useCallback)(function (event) {
    if (readOnly) {
      return;
    }

    setState(event.target.value);

    if (onChange) {
      onChange(event);
    }
  }, [onChange, readOnly]);
  var handleFocus = (0, _react.useCallback)(function () {
    return setFocus(true);
  }, []);
  var isArray = Array.isArray(options);
  var hasNoData = isArray ? !options.length : (0, _isEmpty["default"])(options);
  return /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledContainer, {
    className: className
  }, readOnly && /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledReadOnly, null), (label || showSecondaryLabel || required) && /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledLabel, {
    htmlFor: id,
    size: size,
    focus: focus,
    filled: state !== '',
    floatingLabel: floatingLabel
  }, label, required && /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledDropdownRequired, {
    disabled: disabled
  }, "*"), showSecondaryLabel && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, ":\xA0"), /*#__PURE__*/_react["default"].createElement("span", null, secondaryLabel))), /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledSelectContainer, {
    disabled: disabled,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledSelect, {
    className: "".concat(state !== '' ? 'filled' : ''),
    disabled: disabled || hasNoData,
    error: !!fieldErrors,
    floatingLabel: floatingLabel,
    readOnly: readOnly,
    id: id,
    name: id,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    ref: register(validations)
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    disabled: true,
    hidden: true
  }, firstOptionText || label), isArray ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, options.map(function (option) {
    var text = option.text,
        optionValue = option.value;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: "".concat(id, "-").concat(optionValue),
      value: optionValue
    }, text);
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Object.keys(options).map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledOptionGroup, {
      key: "".concat(id, "-").concat(option),
      label: option
    }, options[option].map(function (optGroupOption) {
      var text = optGroupOption.text,
          optionValue = optGroupOption.value;
      return /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledOption, {
        key: "".concat(id, "-").concat(optionValue),
        value: optionValue
      }, text);
    }));
  })))), !disabled && fieldErrors && /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledErrorText, null, fieldErrors.message));
};

Dropdown.defaultProps = {
  className: null,
  disabled: false,
  error: undefined,
  firstOptionText: 'Select',
  floatingLabel: true,
  label: '',
  secondaryLabel: '',
  showSecondaryLabel: false,
  onChange: null,
  options: [],
  readOnly: false,
  size: 'normal',
  validations: null,
  value: ''
};
Dropdown.propTypes = {
  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Sets if dropdown should be disabled */
  disabled: _propTypes.bool,

  /** Provides error to the field. Message is optional */
  error: (0, _propTypes.shape)({
    message: _propTypes.string
  }),

  /** Sets text of the first option */
  firstOptionText: _propTypes.string,

  /** Sets if dropdown should be presented with or withour a floating label */
  floatingLabel: _propTypes.bool,

  /** Id of the dropdown */
  id: _propTypes.string.isRequired,

  /** Label of the dropdown */
  label: _propTypes.string,

  /** Displays texts after label */
  secondaryLabel: _propTypes.string,

  /** Determines if the secondary label should be shown */
  showSecondaryLabel: _propTypes.bool,

  /** Function to be called when the dropdown value is changed */
  onChange: _propTypes.func,

  /** Dropdown options. */
  options: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)((0, _propTypes.shape)({
    text: _propTypes.string,
    value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
  })), (0, _propTypes.shape)((0, _defineProperty2["default"])({}, _propTypes.string, (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    text: _propTypes.string,
    value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
  }))))]),

  /** Simulate readonly behavior */
  readOnly: _propTypes.bool,

  /** Size of the dropdown */
  size: (0, _propTypes.oneOf)(['small', 'normal']),

  /** Validations to be provided for the component. */
  validations: (0, _propTypes.shape)({
    required: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
    max: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    maxLength: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    min: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    minLength: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    pattern: (0, _propTypes.shape)({
      value: (0, _propTypes.instanceOf)(RegExp),
      message: _propTypes.string
    }),
    validate: (0, _propTypes.shape)({})
  }),

  /** Initial value of the dropdown */
  value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
};
Dropdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dropdown",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets if dropdown should be disabled",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Provides error to the field. Message is optional",
      "type": {
        "name": "shape",
        "value": {
          "message": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "firstOptionText": {
      "defaultValue": {
        "value": "'Select'",
        "computed": false
      },
      "description": "Sets text of the first option",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "floatingLabel": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Sets if dropdown should be presented with or withour a floating label",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Label of the dropdown",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "secondaryLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Displays texts after label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "showSecondaryLabel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Determines if the secondary label should be shown",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Function to be called when the dropdown value is changed",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "Dropdown options.",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {
              "text": {
                "name": "string",
                "required": false
              },
              "value": {
                "name": "union",
                "value": [{
                  "name": "number"
                }, {
                  "name": "string"
                }],
                "required": false
              }
            }
          }
        }, {
          "name": "shape",
          "value": {
            "@computed#string": {
              "name": "arrayOf",
              "value": {
                "name": "shape",
                "value": {
                  "text": {
                    "name": "string",
                    "required": false
                  },
                  "value": {
                    "name": "union",
                    "value": [{
                      "name": "number"
                    }, {
                      "name": "string"
                    }],
                    "required": false
                  }
                }
              },
              "required": false
            }
          }
        }]
      },
      "required": false
    },
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Simulate readonly behavior",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "size": {
      "defaultValue": {
        "value": "'normal'",
        "computed": false
      },
      "description": "Size of the dropdown",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'normal'",
          "computed": false
        }]
      },
      "required": false
    },
    "validations": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Validations to be provided for the component.",
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "union",
            "value": [{
              "name": "bool"
            }, {
              "name": "string"
            }],
            "required": false
          },
          "max": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "maxLength": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "min": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "minLength": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "pattern": {
            "name": "shape",
            "value": {
              "value": {
                "name": "instanceOf",
                "value": "RegExp",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "validate": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Initial value of the dropdown",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "id": {
      "description": "Id of the dropdown",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = Dropdown;
exports["default"] = _default;